import httpApi from 'hooks/api/httpApi';
import useSWR from 'swr';

const ENDPOINT = '/api/v1/teaor';

interface TEAORNumber {
    teaor_number: string;
    teaor_text: string;
    country_code: string;
}

type UseTEAORNumbers = (countryCode: string) => {
    listOfTEAORNumbers: TEAORNumber[];
    loading: boolean;
};

const getTEAORNumbers = async (countryCode: string): Promise<TEAORNumber[]> => {
    return httpApi
        .get<TEAORNumber[]>(ENDPOINT, { country_code: countryCode })
        .then((response) => response.getData())
        .catch(() => []);
};

const useTEAORNumbers: UseTEAORNumbers = (countryCode) => {
    const { data, isLoading } = useSWR(
        `<teaor-numbers-by-${countryCode}>`,
        () => getTEAORNumbers(countryCode),
        {
            dedupingInterval: 600000, // 10min
            revalidateOnReconnect: false,
            revalidateOnFocus: false,
        }
    );

    return {
        listOfTEAORNumbers: data,
        loading: isLoading,
    };
};

export default useTEAORNumbers;
